export default __webpack_public_path__ + "static/media/keyStrokes&Clicks.f9856086.gif";